// extracted by mini-css-extract-plugin
export default {"contact":"index-module--contact--dcc42","register":"index-module--register--a0ec5","additional":"index-module--additional--f45e0","add":"index-module--add--ca815"};